export function safeReturnUrl(value: string | null | undefined): string {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/auth')) {
        return '/';
    }
    return value;
}
